import React, { useEffect } from "react";
import "./NotificationModal.css";

const ICONS = { success: "✓", error: "✕", warning: "!", info: "i" };

// Shared success/error/warning/info modal — used consistently across the public contact form
// and the admin panel (quote/booking/message status changes, admin CRUD) instead of each page
// rolling its own inline banner text.
const NotificationModal = ({ variant = "info", title, message, onClose }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  if (!title && !message) return null;

  return (
    <div className="notify-modal-backdrop" onClick={onClose}>
      <div
        className={`notify-modal notify-modal--${variant}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="notify-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="notify-modal-icon">{ICONS[variant] || ICONS.info}</div>
        {title && <h3 id="notify-modal-title">{title}</h3>}
        {message && <p className="notify-modal-message">{message}</p>}
        <button type="button" className="notify-modal-close" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default NotificationModal;
